import { Middleware } from "@reduxjs/toolkit";
import { addAudienceViewReaction } from "modules/broadcast/AudienceView/actions";
import { selectIsAudienceViewEnabled } from "modules/event/selectors";
import { selectIsAudienceViewExpanded } from "modules/broadcast/AudienceView/selectors";
import { selectUserId } from "modules/auth/redux/selectors";
import { playFloatingReaction } from "./playFloatingReaction";
import ActionTypes from "../redux/constants";
import { createDelayingQueue } from "../createDelayingQueue";
import {
  AUDIENCE_VIEW_REACTION_INTERVAL,
  FLOATING_REACTION_INTERVAL,
  MAX_SIMULTANEOUS_AUDIENCE_VIEW_REACTIONS,
  MAX_SIMULTANEOUS_FLOATING_REACTIONS,
} from "../constants";

export const floatingReactionsQueue = createDelayingQueue(
  MAX_SIMULTANEOUS_FLOATING_REACTIONS,
  FLOATING_REACTION_INTERVAL,
);

export const audienceViewReactionsQueue = createDelayingQueue(
  MAX_SIMULTANEOUS_AUDIENCE_VIEW_REACTIONS,
  AUDIENCE_VIEW_REACTION_INTERVAL,
);

export const reactionsMiddleware: Middleware =
  (store) =>
  (next) =>
  (
    action,
    // eslint-disable-next-line consistent-return
  ) => {
    if (action.type !== ActionTypes.SCHEDULE_ADD_REACTION) return next(action);

    // eslint-disable-next-line consistent-return
    if (!document.hasFocus()) return;

    const currentUserId = selectUserId(store.getState());
    const isAudienceViewExpanded = selectIsAudienceViewExpanded(
      store.getState(),
    );
    const isAudienceViewEnabled = selectIsAudienceViewEnabled(store.getState());
    const {
      reaction: { reactionType, userId },
    } = action.payload;

    if (!(isAudienceViewExpanded && isAudienceViewEnabled)) {
      audienceViewReactionsQueue.stop();

      if (userId === currentUserId) {
        playFloatingReaction(reactionType);
      } else {
        floatingReactionsQueue.enqueue(() =>
          playFloatingReaction(reactionType),
        );
      }
    } else {
      floatingReactionsQueue.stop();

      if (userId === currentUserId) {
        store.dispatch(addAudienceViewReaction(userId, reactionType));
      } else {
        audienceViewReactionsQueue.enqueue(() =>
          store.dispatch(addAudienceViewReaction(userId, reactionType)),
        );
      }
    }
  };
